import { AxiosRequestConfig, AxiosResponse } from 'axios';
import {
  FinderDatesResponse,
  FinderFiltersCinemas,
  FinderFiltersExperiences,
  FinderFiltersFilm,
  FinderResultsCount,
  FinderResultsRequest,
  FinderResultsResponse,
  RecentAddSearchModel,
  dataSearch,
} from './models';
import {
  axiosInstance,
  createInfiniteQuery,
  createMutation,
  createQuery,
} from '../../libs';

const url = 'film-finder';
export const recentSearchUrl = 'recent-searches';

// Server Side //

export const getFinderDates = (
  config: AxiosRequestConfig = {}
): Promise<FinderDatesResponse> => {
  return axiosInstance
    .get(`${url}/dates`, config)
    .then((res: AxiosResponse<FinderDatesResponse>) => res?.data);
};

export const getFinderFilms = (
  params: FinderResultsRequest,
  config: AxiosRequestConfig = {}
): Promise<FinderFiltersFilm> => {
  return axiosInstance
    .get(`${url}/filters/films`, { params, ...config })
    .then((res: AxiosResponse<FinderFiltersFilm>) => res?.data);
};
export const getFinderCinemas = (
  params: FinderResultsRequest,
  config: AxiosRequestConfig = {}
): Promise<FinderFiltersCinemas> => {
  return axiosInstance
    .get(`${url}/filters/cinemas`, { params, ...config })
    .then((res: AxiosResponse<FinderFiltersCinemas>) => res?.data);
};
export const getFinderExperiences = (
  params: FinderResultsRequest,
  config: AxiosRequestConfig = {}
): Promise<FinderFiltersExperiences> => {
  return axiosInstance
    .get(`${url}/filters/experiences`, { params, ...config })
    .then((res: AxiosResponse<FinderFiltersExperiences>) => res?.data);
};

export const getFinderResultCount = (
  params: FinderResultsRequest,
  config: AxiosRequestConfig = {}
): Promise<FinderResultsCount> => {
  return axiosInstance
    .get(`${url}/result-count`, { params, ...config })
    .then((res: AxiosResponse<FinderResultsCount>) => res?.data);
};

export const useGetFinderResults = createInfiniteQuery<FinderResultsResponse>(
  {
    method: 'get',
    url: `${url}`,
  },
  {
    staleTime: 0,
    keepPreviousData: false,
  }
);

export const useGetSearchResults = createQuery<dataSearch, unknown>(
  {
    method: 'get',
    url: `${url}/search`,
  },
  {
    keepPreviousData: false,
  }
);

export const useGetRecentSearchResults = createQuery<dataSearch, unknown>({
  method: 'get',
  url: `${recentSearchUrl}`,
});

export const useAddRecentSearchResult = createMutation<RecentAddSearchModel, unknown>({
  method: 'post',
  url: `/${recentSearchUrl}`,
});

export const useClearSearchHistory = createMutation<null, unknown>({
  method: 'delete',
  url: `/${recentSearchUrl}`,
});

export const useGetFilmCinemas = createQuery<FinderFiltersCinemas>({
  method: 'get',
  url: `${url}/films/:id/cinemas`,
});
